module.exports = __webpack_public_path__ + "static/img/wzmacniacz4.5971d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia_KOPIA/wzmacniacz4.png
// module id = qDll
// module chunks = 1